var _use, _use2, _use3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSardinia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 895,
    height: 600,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h895v600H0z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      marker: "none",
      visibility: "visible",
      display: "inline",
      overflow: "visible",
      enableBackground: "accumulate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.019 0v270.053H0v59.894h418.019V600h58.962V329.947H895v-59.894H476.981V0H418.02z",
    style: {
      fill: "#d81921",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      marker: "none",
      visibility: "visible",
      display: "inline",
      overflow: "visible",
      enableBackground: "accumulate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-358.642 251.264c20.142 9.347 25.065 21.656 33.96 31.474 8.895 9.817 22.157 30.937 47.952 23.797.809-5.29 4.14-19.877 13.867-26.475 6.01-3.673 13.342-8.925 14.677-17.85 10.673 2.678 37.402 4.82 38.692-9.37.445-4.91-3.746-12.43.736-17.607 1.013.032 6.685.146 8.172-.55 1.556-1.845.02-8.555-1.108-10.046l.013-.062c2.662-.243 9.532-6.542 1.082-11.005-2.228-2.628-1.838-4.776-1.83-7.198 1.396.02 4.827-.02 5.329-.054 8.907-.033 7.763-5.8 5.197-11.936-1.779-4.016-11.809-23.205-13.588-25.882-1.779-2.677-1.779-4.016-.445-6.694 1.335-2.677.89-7.14 0-10.263-.89-3.124-2.668-8.033-1.334-9.371 1.334-1.34.89-5.801.445-6.694-.445-.892-.445-3.124-.445-4.016 0-.893-.445-3.124-1.779-4.016-1.334-.893-2.224-4.016-1.334-4.909.89-.892-.445-7.14-1.78-7.586-1.333-.446-4.002-1.339-5.336-4.462.158-4.407-3.292-9.409-5.337-11.603-1.334-1.338-.89-5.8-.89-5.8l-3.913.089c-.426-.143-3.647-4.552-6.76-5.445-3.113-.892-10.23-4.462-10.23-4.462l-4.892-5.355-4.447 2.231s-3.558-1.339-6.671-1.785c-3.113-.446-9.784-2.677-12.008-6.247-2.224-3.57-1.78 4.248-1.85 4.676-.284.071-3.932-1.999-10.158-1.552-6.227.446-13.342 3.123-15.566 2.23-2.224-.892-4.448 1.786-4.448 1.786s-4.447 2.677-8.005 2.677h-6.671l-.445 3.124s-6.671 2.302-9.784 3.641c-3.113 1.339-5.782 3.052-9.785 3.499-4.002.446-5.336 1.785-5.336 1.785l1.778 3.57s-4.802.982-6.226 5.8c-2.668 3.57-6.226 9.372-8.895 9.818-2.668.446-4.447 1.785-4.447 1.785l3.558 4.462s-.89 1.34-2.669 3.124c-1.779 1.785-5.337 4.909-5.337 4.909l2.224 4.016s0 .892-.445 3.124c-.445 2.23-.445 6.247-2.668 7.14-2.224.892-2.224 3.57-2.224 3.57s-.445.446 2.224 1.338c2.668.893 4.447.893 3.113 2.678a345.637 345.637 0 0 0-3.558 4.908s2.224 1.339 4.448 1.785c2.223.446 4.447.446 4.447.446s-1.779 8.479-3.558 9.818c-1.779 1.338 2.669 2.231 5.337.892 2.668-1.338 1.001 4.016-.778 4.463-1.78.446.646 1.07 2.736 1.092 1.779-.446 4.069-.134 3.046 2.5-1.335 3.57-2.78 5.332.778 7.117 3.558 1.785 6.782 9.818 5.003 12.495-1.779 2.678-2.78 6.694-2.78 6.694l8.45.446s.579 1.339-1.645 3.57-4.447 4.775-4.136 5.4c-.067.965 6.693.573 6.626 1.539-5.752 28.525-19.412 36.525-19.43 38.028l1.081.76z",
    style: {
      fill: "#000",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 1.26046431
    },
    transform: "matrix(.7689 0 0 .76825 440.764 -8.998)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-216.936 114.627c2.964 2.23 5.557 5.948 2.964 8.179-3.335 2.974-4.817 4.089-4.817 4.089s5.928-1.859 7.04.371c1.111 2.231 2.408 5.623 0 6.32-1.853 1.115-5.928 3.346-5.928 3.346s9.262-1.115 7.039-.744c1.112 2.974 2.223 8.179-3.705 10.41-5.928 2.23-24.452 8.92-27.787 10.78-3.334 1.858-10.744 2.974-14.45 2.974-3.704 0-17.414.743-15.19.743l8.152 2.23c1.39.14-16.858 6.226-19.545 5.67-1.435-3.347-20.098-20.911-30.472.65-1.112 4.833 2.593 12.268 6.298 13.755 3.705 1.486 5.558 3.345 7.04 7.434 1.482 4.09 5.276 11.384 9.353 10.782 5.606-3.672 8.06-3.347 5.466-.373-2.871 4.09-9.586 4.276-12.967-.743-2.825-3.485-5.37-12.5-11.115-14.87-2.964-1.115-6.669-8.178-6.669-8.178s-5.186-.372-7.41 1.858c-2.222 2.23-7.78 2.23-11.114 1.86-3.335-.373-8.939-1.627-7.086-1.627 1.852 0-5.142-.232-7.365.14s-1.48-5.577 2.224-8.551c3.705-2.974 14.08-7.807 16.302-10.78 2.223-2.974 18.154-11.896 22.6-12.268 4.446-.372 10.004-3.346 10.004-3.346s-8.338-.138-4.262-.882c4.075-.743 12.042-3.95 16.117-5.437 4.076-1.487 7.41-1.487 11.856-1.487s33.96-7.253 41.326-11.763c5.557-1.858-26.367 7.441-30.072 7.813-6.298.93-8.29-.325 2.084-5.344 4.446-2.602 24.246-13.02 40.093-17.373 1.622 1.628 1.032 2.132 3.996 4.362z",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: ".15755804px"
    },
    transform: "matrix(.7689 0 0 .76825 440.764 -8.998)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-297.838 175.826c-.144.017-.742.123-1.125.525-.425.55-.785 1.044-1 1.576-.158.709-.365 1.294-.25 1.969.24.661.561 1.13 1 1.575a6.73 6.73 0 0 0 1.375 1.313c.58.276 1.135.812 1.625 1.05.235.32.838.555 1.125.92.333.448.59.67.625 1.313.217.637.289 1.423.376 2.1.122.745.297 1.445.375 2.101.312.562.653.85 1.375 1.05.597.107 1.215.132 1.875.132.373-.359 1.01-.764 1.375-1.182v-1.05",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: "3.18875313px",
      strokeLinecap: "round"
    },
    transform: "matrix(.7689 0 0 .76825 440.764 -8.998)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-287.419 172.896c-3.197-5.161-23.218-14.647-18.352 3.767 1.113 1.953-.973 2.79-1.529 1.395-5.144-21.762 16.962-12.694 20.437-6.975 1.39 2.372-.556 1.953-.556 1.813z",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: "1.26046431px"
    },
    transform: "matrix(.7689 0 0 .76825 440.764 -8.998)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-215.263 141.51c-7.507-.14-15.432.279-21.55 4.184-6.117 3.906-11.539 5.022-18.073 5.022-6.534 0-9.871.14-9.871.14h0",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "2.52092862px",
      strokeLinecap: "round"
    },
    transform: "matrix(.7689 0 0 .76825 440.764 -8.998)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-307.656 152.818c-12.546 4.872-14.77 6.306-20.067 9.745-5.297 3.44-7.255 4.013-11.716 6.88-3.318 2.006-5.297 4.299-5.297 4.299-2.857 2.293 12.395-8.886 22.304-6.593 3.624 0 4.182 0 7.527-3.726 3.346-3.726 7.25-6.88 12.825-9.172 5.576-2.293 15.334-6.02 15.334-6.02",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "2.49044442px"
    },
    transform: "matrix(.7689 0 0 .76825 440.764 -8.998)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-321.597 174.602c-.76 0-3.925-.12-5.142.286-1.062.144-2.761.283-3.714.574-1.615.192-3.105.53-4.856.573-1.884.017-2.554.594-4.285.86-.541.678-1.564 1.493-2.286 2.006",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "2.20581269px",
      strokeLinecap: "round"
    },
    transform: "matrix(.7689 0 0 .76825 440.764 -8.998)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-217.944 164.038c-4.606 6.374-11.666 9.87-19.383 11.527.195 1.874 9.366 1.993 12.783 6.338",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: "2.83604479px"
    },
    transform: "matrix(.7689 0 0 .76825 440.764 -8.998)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-390.265 90.619c-.148 1.627-.657 8.734.049 8.814 4 .573 6.758 1.245 10.186 4.685 3.428 3.44 11.273 9.296 15.72 1.257 2.286-4.586-3.28-6.73-6.137-6.73-2.807-.1-7.218-2.275-11.789-3.422-4.57-1.146-6.426-4.093-6.997-3.52l-1.032-1.084zM-408.278 108.177c-.626-.346-3.59-4.32-2.056-9.163 2.223-3.345-10.066 3.602-7.472 7.32 3.282 2.565 9.784 2.534 9.528 1.843z",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeWidth: "2.52092862px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter"
    },
    transform: "matrix(.7689 0 0 .76825 440.764 -8.998)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-379.012 92.66c.052-.759.144-7.542.03-9.04-2.297-.345-9.096-1.334-10.578.896-5.27 7.99 10.079 11.971 10.45 10.856l.098-2.713zM-366.616 108.68l-9.633 33.456s-5.437 23.75 11.115 30.111c5.187.372 7.04-.371 7.04-.371l-1.482 8.178c-7.348 7.602-12.086 5.806-18.384 3.204-6.299-2.602-6.554-2.806-9.889-4.665-3.334-1.859-7.931-12.336-8.443-15.315-1.43-7.702-6.256-22.832-20.747-54.97 2.614-.23 19.662 1.497 20.81 1.497.574.922 3.255 5.316 7.384 7.053 4.534 1.858 11.066-3.5 4.446-7.807-3.236-2.069-13.971.37-13.771-5.257.273-4.888 7.472-4.408 10.436-4.036 2.964.371 7.04 3.717 8.892 5.576 4.149 4.162 10.003 4.832 12.226 3.345z",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeWidth: "2.52092862px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter"
    },
    transform: "matrix(.7689 0 0 .76825 440.764 -8.998)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-351.796 188.232c-2.223 3.718-4.446 8.178-5.557 14.126-1.112 5.948-4.321 14.268-12.597 16.357-6.669 1.859-12.597 4.833-14.079 10.037-1.482 5.204-2.541 11.843-2.541 11.728l-10.311-14.64c.114-1.957.193-6.727.193-12.303.115-8.11 6.105-10.09 12.033-12.32 5.928-2.23 12.57-5 14.423-8.346 1.853-3.346 6.58-9.1 9.174-11.33 2.593-2.23 9.262 6.691 9.262 6.691z",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeWidth: "2.52092862px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter"
    },
    transform: "matrix(.7689 0 0 .76825 440.764 -8.998)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-362.694 257.24c-5.727 10.333-7.038 23.6-9.393 33.486-4.087-7.788-10.448-13.34-17.155-17.71-.393-7.755-2.35-18.46-4.573-21.806-10.737-15.7-3.181-24.689-3.181-24.689 10.73 12.643 11.1 21.689 34.284 30.7l.018.02z",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeWidth: "2.52092862px"
    },
    transform: "matrix(.7689 0 0 .76825 440.764 -8.998)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-352.49 289.177c.296 2.564-3.125 11.48-8.913 11.878-5.687.391-8.968-3.998-10.008-9.129l2.85-17.23 16.072 14.48z",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeWidth: "2.52092862px"
    },
    transform: "matrix(.7689 0 0 .76825 440.764 -8.998)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-352.45 174.888c1.143-3.153-.57-3.153-3.713-1.72-5.142 3.153-1.428 11.179 4.285 12.899 3.142 1.433 4.856-2.293.285-4.013-4.285-1.147-.856-7.452-.856-7.166h-.286.286z",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: "1.26046431px"
    },
    transform: "matrix(.7689 0 0 .76825 440.764 -8.998)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-389.587 223.937v.39c0-1.05.02-.517-.285 1.554 0 2.104-.157 3.87-.286 5.832 0 1.624.192 2.788.286 4.276M-386.73 225.879v.71c0-1.314.038-.943-.285 1.064-.115 2-.515 3.046-.572 4.97 0 1.952.233 3.468.286 5.324M-385.301 268.617h-.286c.076.27 0 1.806 0 2.832 0 1.545.029 3.054.286 4.047M-382.159 270.05v.573-.573.573-.573c-.062 2.118-.286 3.29-.286 5.446 0 .659-.123 1.16.286 1.433M-379.302 271.77c-.117 2.308-.501 3.819-.572 6.19 0 1.192.239 1.325.286 2.409M-375.874 273.516v.362c0-.978.018-.48-.286 1.449-.052 1.78-.286 2.738-.286 4.708.054 1.892.47 2.68.572 4.346M-373.303 274.636c0 .512-.155 2.5-.286 3.726v4.013c.159 1.336.45 2.771.857 3.726v.86M-392.443 224.569c-.073.538-.496 2.594 0 3.915 0 1.168.133 1.767.286 2.61",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeWidth: "1.57558048px"
    },
    transform: "matrix(.7689 0 0 .76825 440.764 -8.998)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-359.457 175.006c-3.834.789-13.173 0-16.909-2.762l-3.735-2.762M-359.47 176.892c-3.662 1.385-13.008 2.083-17.131-.054l-4.123-2.137",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeWidth: 1.26046431
    },
    transform: "matrix(.7689 0 0 .76825 440.764 -8.998)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-359.162 181.91c-1.966 2.368-3.342 3.552-3.932 6.708l-.59 3.157M-356.802 183.094c-2.36 3.354-3.933 4.538-4.72 7.891l-.786 3.354",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeWidth: "1.26046431px"
    },
    transform: "matrix(.7689 0 0 .76825 440.764 -8.998)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-354.836 185.264c-.983 5.13-4.916 14.796-7.865 17.953l-2.95 3.156",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeWidth: 1.26046431
    },
    transform: "matrix(.7689 0 0 .76825 440.764 -8.998)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-369.579 294.225c1.984-.258 5.843-3.473 6.71-4.628.866-1.155.93-1.641.93-1.641",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeWidth: "1.50726712px"
    },
    transform: "matrix(.7689 0 0 .76825 440.764 -8.998)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-368.207 296.836c2.145-.52 6.321-4.046 7.259-5.238.938-1.193 1.127-1.504 1.127-1.504",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeWidth: "1.50713217px"
    },
    transform: "matrix(.7689 0 0 .76825 440.764 -8.998)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-367.03 299.241c2.265-.25 6.951-3.809 8.048-5.098l1.096-1.29",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeWidth: "1.70484364px"
    },
    transform: "matrix(.7689 0 0 .76825 440.764 -8.998)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-395.17 120.505c.288 2.394.433 7.109-.435 10.083l-.867 2.974M-402.111 112.961c1.663.58 4.12 1.886 4.916 2.974l.795 1.088",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeWidth: "1.26046431px"
    },
    transform: "matrix(.7689 0 0 .76825 440.764 -8.998)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-382.046 115.109c-3.582 6.316-2.47 26.952-1.73 29.302l.742 2.35",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeWidth: "1.65765059px"
    },
    transform: "matrix(.7689 0 0 .76825 440.764 -8.998)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-370.369 102.308c1.475.494 4.522 2.91 4.768 4.242",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeWidth: "1.26046431px"
    },
    transform: "matrix(.7689 0 0 .76825 440.764 -8.998)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-372.728 104.035c1.474.493 4.522 2.91 4.768 4.241",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeWidth: 1.26046431
    },
    transform: "matrix(.7689 0 0 .76825 440.764 -8.998)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-224.647 170.37c2.92-.158 3.157 8.338-.606 8.142",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.82767344
    },
    transform: "matrix(.7689 0 0 .76825 440.764 -8.998)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-225.06 170.54.1 7.12",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 4.50211143
    },
    transform: "matrix(.7689 0 0 .76825 440.764 -8.998)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-225.26 170.37c-2.92-.158-3.157 8.338.607 8.142",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.82767344
    },
    transform: "matrix(.7689 0 0 .76825 440.764 -8.998)"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: 895,
    height: 600,
    transform: "translate(0 326.053)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: 895,
    height: 600,
    transform: "translate(475.022)"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: 895,
    height: 600,
    transform: "translate(475.022 326.053)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSardinia);
export default __webpack_public_path__ + "static/media/sardinia.e3c4a3cdf3a53f33f8db21f5eab71064.svg";
export { ForwardRef as ReactComponent };